import React, { useState, useEffect } from 'react';
import Offcanvas from 'react-bootstrap/Offcanvas';
import './css/restaurant.css';
import Sidebar from '../../components/SidebarResto';
import { Outlet, useLocation, useNavigate, Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { suprimerRestaurant, AjouteRestaurant } from '../../Redux/actions/actionRestaurant';
import { suprimerUrlSociete } from '../../Redux/actions/actionUrlSociete';
import DataSidebar from '../../Data/dataResto.json';
import { AfficheReservationResto, ChangeStatus } from '../../Api/RestaurantApi/ReservationApi';
import { AfficheRestaurant } from '../../Api/RestoPageApi';

const RestaurantLayout = () => {
  const [show, setShow] = useState(false);
  const [data, setData] = useState([]);


  const restaurant = useSelector((state) => state.restaurant);
  const urlSociete = useSelector((state) => state.urlSociete);

  const dispatch = useDispatch();
  let location = useLocation();
  let navigate = useNavigate();

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  useEffect(() => {
    const idResto = JSON.parse(localStorage.getItem('idResto'));
    if (idResto) {
      AfficheRestaurant(idResto)
      .then(function (response) {
        console.log("donner resto",response.data.donner);
        dispatch(AjouteRestaurant(response.data.donner));
      })
      .catch(function (error) {
        console.log(error);
      });
    }
  }, []);


  useEffect(() => {
    const interval = setInterval(() => {
      AfficheResaResto();
    }, 10000);
    return () => clearInterval(interval);
  }, []);

  const AfficheResaResto = () => {
    AfficheReservationResto(restaurant.id)
      .then(function (response) {
        console.log("data navBar =>", response.data.donner);
        setData(response.data.donner);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const handleChangeStatus = () => {
    const dataAutre = { idRestaurant: restaurant.id };
    ChangeStatus(dataAutre).then(function (response) {
      if (response.data.title === "success") {
      }
    }).catch(function (error) {
      console.log(error.response);
    });
  }



  const pathRouter = (element, index) => {
    const existeStatus = data.filter((el) => el.status === "Non_lue");
    if (element.children) {
      const exist = element.children.find((child) => child.path === location.pathname);
      if (exist) {
        if (element.title === "Etat des resérvations" && existeStatus.length !== 0) {
          return (<span className='active' key={index} onClick={handleChangeStatus}><i className='fa fa-certificate'></i> {element.title}</span>);
        } else {
          return (<span className='active' key={index}>{element.title}</span>);
        }

      } else {
        if (element.title === "Etat des resérvations" && existeStatus.length !== 0) {
          return (<span key={index} onClick={handleChangeStatus}><Link to={element.children[0].path} className='link' > <i className='fa fa-certificate'></i> {element.title}</Link></span>);
        } else {
          return (<span key={index}><Link to={element.children[0].path} className='link' >{element.title}</Link></span>);
        }

      }

    } else {
      if (location.pathname === element.path) {
        if (element.title !== "Contact" && element.title !== "Aide") {
          if (element.title === "Etat des resérvations" && existeStatus.length !== 0) {
            return (<span className='active' key={index} onClick={handleChangeStatus}><i className='fa fa-certificate'></i> {element.title}</span>);
          } else {
            return (<span className='active' key={index}>{element.title}</span>);
          }

        }
      } else {
        if (element.title !== "Contact" && element.title !== "Aide") {
          if (element.title === "Etat des resérvations" && existeStatus.length !== 0) {
            return (<span key={index}><Link to={element.path} className='link' onClick={handleChangeStatus}><i className='fa fa-certificate'></i> {element.title}</Link></span>);
          } else {
            return (<span key={index}><Link to={element.path} className='link' >{element.title}</Link></span>);
          }

        }
      }
    }
  }

  const handleLogot = () => {
    localStorage.clear();
    dispatch(suprimerRestaurant());
    navigate('/loginRestaurant');
  }

  console.log("Url societe=>", urlSociete);

  const handleSociete = () => {
    localStorage.removeItem('urlSociete');
    dispatch(suprimerUrlSociete());
    localStorage.removeItem('restaurant');
    localStorage.removeItem('tokenRestaurant');
    dispatch(suprimerRestaurant());
    if (urlSociete === "/societe/gererRestaurant") {
      navigate('/societe/gererRestaurant');
    }
  }

  return (
    <div className='restaurantLayout'>
      <div className='main'>
        <div className='sidebar_full'>
          <Sidebar hide={handleClose} restaurant={restaurant} logout={handleLogot} />
        </div>
        <div className='bloc_restaurant'>
          <div className='nav fixed-top'>
            <div className='header w-100 d-flex justify-content-between'>
              <i className='fa fa-navicon' onClick={handleShow}></i>
              {localStorage.getItem('urlSociete') !== null ?
                <div className='d-flex'>
                  <div className='quitter' onClick={handleSociete}>
                    <span>Quitter</span>
                  </div>
                  <div className='deconnect' onClick={handleLogot}>
                    <span>Se déconnecter</span>
                  </div>
                </div>
                :
                <div className='deconnect' onClick={handleLogot}>
                  <span>Se déconnecter</span>
                </div>
              }
            </div>
            <div className='suite_sidebar'>
              <div className='d-flex justify-content-between'>
                {DataSidebar.map((element, index) => pathRouter(element, index))}
              </div>
            </div>
          </div>
          <Outlet />
        </div>
        <div className='content_offcanvas'>
          <Offcanvas show={show} onHide={handleClose}>
            <Offcanvas.Body>
              <div className='sidebar_mobileResto'>
                <Sidebar restaurant={restaurant} hide={handleClose} logout={handleLogot} />
              </div>
            </Offcanvas.Body>
          </Offcanvas>
        </div>
      </div>
    </div>
  )
}

export default RestaurantLayout